export const mode = process.env.MODE;
export const isProd = mode === "production";
//# sourceMappingURL=mode.js.map